(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const root = document.getElementById('MainContent');
  if (!root) return;
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('nab-enter');
      observer.unobserve(entry.target);
      entry.target.addEventListener('animationend', () => entry.target.classList.remove('nab-enter'), {once:true});
    });
  }, {threshold:.08});
  const scan = () => root.querySelectorAll('.product-card-wrapper, .nab-category').forEach(el => {
    if (seen.has(el)) return;
    seen.add(el); observer.observe(el);
  });
  scan();
  let scheduled = false;
  new MutationObserver(records => {
    if (scheduled || !records.some(r => r.addedNodes.length)) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  }).observe(root, {childList:true, subtree:true});
})();
